module.exports = __webpack_public_path__ + "static/media/logo.c90025cb.png";